module.exports = __webpack_public_path__ + "static/media/charts_guy.c6362a28.svg";